var cached = {}

export function cache (target, name, descriptor) {
  const original = descriptor.value
  descriptor.value = function (...args) {
    const cachedName = `${target.constructor.name}.${name}`
    try {
      if (cached[cachedName]) {
        return cached[cachedName]
      }
      cached[cachedName] = original.apply(this, args)
      return cached[cachedName]
    } catch (e) {
      console.log(e)
    }
  }
  return descriptor
}
